<template>
    <page>
        <module enable-flex>
            <m-search ref="search" @search="searchHandle">
                <c-form>
                    <c-form-item type="input" label="资源名称" name="title"></c-form-item>
                    <c-form-item type="datetime" label="创建时间" start-name="start_create_date" end-name="end_create_date"></c-form-item>
                </c-form>
            </m-search>

            <m-operate power="b_media_resource_edit">
                <c-button power="b_media_resource_edit" color="sys" @click="uploadHandle">上传资源文件</c-button>
            </m-operate>

            <c-table ref="table">
                <c-table-column
                        label="资源名称"
                        name="title"
                        width="200"
                >
                </c-table-column>

                <c-table-column
                        label="资源类型"
                        name="file_model"
                        width="60"
                >
                    <template v-slot="{data}">
                        <span v-if="data.file_model == 'xls'||data.file_model == 'xlsx'"><i class="tf tf-file-xls"></i></span>
                        <span v-else-if="data.file_model == 'doc'||data.file_model == 'docx'"><i class="tf tf-file-doc"></i></span>
                        <span v-else-if="data.file_model == 'ppt'||data.file_model == 'pptx'"><i class="tf tf-file-ppt"></i></span>
                        <span v-else-if="data.file_model == 'pdf'"><i class="tf tf-file-pdf"></i></span>
                        <span v-else-if="data.file_model == 'zip'"><i class="tf tf-file-zip"></i></span>
                        <span v-else-if="data.file_model == '7z'"><i class="tf tf-file-7z"></i></span>
                        <span v-else-if="data.file_model == 'rar'"><i class="tf tf-file-rar"></i></span>
                        <span v-else><i class="tf tf-file"></i></span>
                        {{data.file_model}}
                    </template>
                </c-table-column>

                <c-table-column
                        label="资源大小"
                        name="file_size"
                        width="60"
                >
                </c-table-column>

                <c-table-column
                    label="资源路径"
                    name="file_url"
                    width="120"
                >
                    <template v-slot="{data}">
                        <a @click="clipboard(data.file_url)" style="color: blue">&nbsp;复制资源路径</a>
                    </template>
                </c-table-column>

                <c-table-column
                        label="状态"
                        name="state"
                        width="60"
                >
                    <template v-slot="{data}">
                        <span style="color:darkgreen" v-if="data.state==2">启用</span>
                        <span style="color:red" v-if="data.state==1">禁用</span>
                    </template>
                </c-table-column>

                <c-table-column
                        label="创建日期"
                        name="create_date"
                        width="140"
                >
                </c-table-column>

                <c-table-column
                        type="sort"
                        label="排序"
                        name="sort_id"
                        power="b_media_resource_edit"
                        @sort="sortHandle"
                >
                </c-table-column>

                <c-table-column
                        type="button"
                        fixed="right"
                        label="操作"
                        width="160"
                >
                    <template v-slot="{data}">
                        <c-table-button power="b_media_resource_edit" @click="del(data)">删除</c-table-button>
                        <c-table-button power="b_media_resource_edit" v-if="data.state == 1" @click="updateState(2, data)">{{ '启用' }}</c-table-button>
                        <c-table-button power="b_media_resource_edit" v-if="data.state == 2" @click="updateState(1, data)">{{ '禁用' }}</c-table-button>
                    </template>
                </c-table-column>
            </c-table>
        </module>
    </page>
</template>

<script>
import {mapState} from "vuex";
import productInfo from "@/components/public/product_info.vue";

export default {
    name: 'm_media_resource',
    components: {productInfo},

    data() {
        return {
            fileUrl:'',
            disabledFileType :["js", "html", "exe","jsp"]
        }
    },

    computed: {
        ...mapState(['systemConfig'])
    },

    watch: {
    },

    mounted() {
        this.$refs.search.search();

        this.$bus.$on('mediaresource.update', page => {
            this.$refs.table.update(page);
        });
    },

    methods: {
        searchHandle(data) {
            this.$refs.table.load({
                url: '/media/resource/list',
                data
            });
        },

        sortHandle(row, type, next) {
            //row.prev() 上一行数据
            //row.next() 下一行数据
            let submitData = {};
            if (type == 'top' || type == 'bottom') {
                submitData.type = type;
                submitData.id = row.data.id;
            }
            if (type == 'up') {
                submitData.id1 = row.data.id;
                submitData.id2 = row.prev().data.id;
            }
            if (type == 'down') {
                submitData.id1 = row.data.id;
                submitData.id2 = row.next().data.id;
            }
            this.request({
                url: '/media/resource/sort',
                data: submitData,
                loading: true,
                success: data => {
                    if (type == 'top' || type == 'bottom') {
                        this.$refs.table.update();
                    } else {
                        next();
                    }
                }
            });
        },

        del(val) {
            this.$confirm({
                text: '确定要删除当前资源？',  // 提示内容,
                buttonName: '确定',  // 确定按钮文字
                cancelButton: true,  // 是否显示取消按钮
                resolve: () => {
                    this.request({
                        url: '/media/resource/remove',
                        data: {id: val.id},
                        loading: true,
                        success: data => {
                            this.$message({
                                text: '操作成功',
                                icon: 'success'
                            });
                            this.$refs.table.update();
                        }
                    });
                },  // 确定按钮回调
                cancel: () => {
                },  // 取消按钮回调
            });
        },

        updateState(type, val) {
            this.$confirm({
                text: '确定要' + (type == 2 ? '启用' : '禁用') + '资源吗？',  // 提示内容,
                buttonName: '确定',  // 确定按钮文字
                cancelButton: true,  // 是否显示取消按钮
                resolve: () => {
                    this.request({
                        url: '/media/resource/update_state',
                        data: {id: val.id, state: type},
                        loading: true,
                        success: data => {
                            this.$message({
                                text: '操作成功',
                                icon: 'success'
                            });
                            this.$refs.table.update();
                        }
                    });
                },  // 确定按钮回调
                cancel: () => {
                },  // 取消按钮回调
            });
        },

        uploadHandle() {
            this.uploadFile({
                success: data => {
                    this.fileUrl = data.filePath||'';
                    if (!this.fileUrl){
                        this.$message({
                            text: '请上传文件',  // 提示内容,
                            type: 'warn'
                        });
                        return;
                    }
                    var suffix = this.fileUrl.substring(this.fileUrl.lastIndexOf('.')+1).toLowerCase();
                    if (console.log(this.disabledFileType.includes(suffix))){
                        this.$message({
                            text: '不允许上传【'+suffix+'】类型文件',  // 提示内容,
                            type: 'error'
                        });
                        return;
                    }
                    console.log(data);
                    var params = {};
                    params.title = data.fileObj.name;
                    params.file_url = this.fileUrl;
                    params.file_size = data.fileObj.size;
                    params.file_model = suffix;
                    params.state = 2;
                    this.saveUploadFile(params);
                }
            });
        },

        /**
         * 保存上传文件
         * @param stop
         */
        saveUploadFile(data) {
            this.request({
                url: '/media/resource/add',
                data: data,
                loading: true,
                success: data => {
                    this.$message({
                        text: '操作成功',
                        icon: 'success'
                    });
                    this.$refs.table.update();
                }
            });
        },

        downloadFile(file_name,file_path) {
            var suffix = file_path.substring(file_path.lastIndexOf('.')+1)

            this.download({
                fileName:file_name + '.'+suffix,
                url: file_path,
                loading: {
                    message: '数据文件下载中...'
                }
            })
        }
    }
}
</script>